import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { BASE_ENV_CONFIG } from '@gcm/gcm-ui-angular';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideAuth0, authHttpInterceptorFn, AuthClientConfig } from '@auth0/auth0-angular';
import { RuntimeConfigService } from './services/runtime-config.service';
import { APP_CONFIG } from './models/app-config.model';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withXhr(), withInterceptors([authHttpInterceptorFn])),
    provideRouter(routes),
    { provide: BASE_ENV_CONFIG, useFactory: (svc: RuntimeConfigService) => svc.getConfig(), deps: [RuntimeConfigService] },

    { provide: APP_CONFIG, useFactory: (svc: RuntimeConfigService) => svc.getConfig(), deps: [RuntimeConfigService] },
    provideAnimations(),
    provideAuth0(),
    provideAppInitializer(() => {
      const config = inject(APP_CONFIG);
      const auth0Config = inject(AuthClientConfig);
      auth0Config.set({
        domain: config.auth0.domain,
        clientId: config.auth0.clientId,
        authorizationParams: {
          redirect_uri: window.location.origin,
          audience: config.auth0.landingAudience
        },
        httpInterceptor: {
          allowedList: ['/api/*']
        }
      })
    })
    
  ]
};
